import React from "react";
import PropTypes from "prop-types";

export default class SuccessModal extends React.Component {

	render() {
		const { showModal, message, isSuccess, onClose, title } = this.props;
		const modalClass = isSuccess ? "admin-response-modal" : "admin-response-modal error-modal";
		if (!showModal) {
			return null;
		}
		return (
			<div className="modal-overlay">
				<div className={modalClass}>
					{isSuccess && (<img src="images/Success-logo.svg" alt="success" className="success-logo" />)}
					<h4>
						{title || (isSuccess ? "Success" : "Failed")}
					</h4>
					<p>{message}</p>
					<button type="button" className="btn create-btn" onClick={onClose}>OK</button>
				</div>
			</div>
		);
	}
}

SuccessModal.propTypes = {
	showModal: PropTypes.bool.isRequired,
	message: PropTypes.string,
	isSuccess: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string
};
